import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import {
  UiSlider,
  UiIcon,
  UiRadioGroup,
  UiRadio,
  UiFormControlLabel,
} from 'ui-components';
import { getCurrentSlice } from 'utils';

// مقادیر اسلایدر
const marks = [
  {
    value: 0,
  },
  {
    value: 0.33,
  },
  {
    value: 0.66,
  },
  {
    value: 1,
  },
];

const minDistance = 0.33;

export const AdvertFilter = (props) => {
  const dispatch = useDispatch();
  const { componentName, className, parentPlatform } = props;
  const { selectedObjectValues, hasActivateSwitch, isDisabled } = useSelector(
    (state) =>
      parentPlatform
        ? state[state.filterReducer.filtersContext].filters?.[parentPlatform]?.[
            componentName
          ]
        : state[state.filterReducer.filtersContext].filters[componentName]
  );
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );

  const { setAdvertFilterValues } = getCurrentSlice(reducerName);

  const [value, setValue] = useState([0, 1]);

  /**
   * زمانی که مقدار کانتکست خالی شد مقدار رنج در کامپوننت آپدیت شود
   */
  useEffect(() => {
    const _value = [
      selectedObjectValues?.min || 0,
      selectedObjectValues?.max || 1,
    ];

    // توضیحات این قسمت را در پایین صفحه مشاهده کنید
    if (_value[0] === 0.65) {
      _value[0] = 0.33;
    } else if (_value[0] === 0.85) {
      _value[0] = 0.66;
    }
    if (_value[1] === 0.65) {
      _value[1] = 0.33;
    } else if (_value[1] === 0.85) {
      _value[1] = 0.66;
    }

    // اگر قبلا عدم نمایش محتوای تبلیغاتی ست شده بود، چک باکس فعال شود
    if (!selectedObjectValues?.active) {
      _value[1] = 0.33;
    }

    setValue(_value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedObjectValues]);

  /**
   * ذخیره کردن روی کانتکست
   */
  const handleChanged = (min, max, active) => {
    // توضیحات این قسمت را در پایین صفحه مشاهده کنید
    if (min === 0.33) {
      min = 0.65;
    } else if (min === 0.66) {
      min = 0.85;
    }
    if (max === 0.33) {
      max = 0.65;
    } else if (max === 0.66) {
      max = 0.85;
    }
    if (min === 0 && max === 0.33) {
      max = 0.15;
    }

    dispatch(
      setAdvertFilterValues({
        active,
        min,
        max,
        componentName,
        parentPlatform,
      })
    );
  };

  /**
   * اگر چک باکس تغییر کرد اسلایدر فعال بشه و در حالت تیک خوردن مقدار استاندارد، کانتکست هم بشود
   * @param {*} e
   */
  const handleChangeRadio = (e) => {
    if (e?.target?.value == 'exclude') {
      handleChanged(0, 1, true);
    } else {
      handleChanged(0, 0.15, false);
    }
  };

  /**
   * متدی برای کنترل کردن اینکه بازه ابتدا و انتها یکسان انتخاب نشود
   */
  const handleChangeing = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }

    if (activeThumb === 0) {
      setValue([Math.min(newValue[0], value[1] - minDistance), value[1]]);
    } else {
      setValue([value[0], Math.max(newValue[1], value[0] + minDistance)]);
    }
  };

  return (
    <div className={classNames('filter-advert mb-15', className)}>
      {!hasActivateSwitch && (
        <UiRadioGroup onChange={handleChangeRadio}>
          <UiFormControlLabel
            className='mr-0'
            label='عدم نمایش مطالب تبلیغاتی'
            control={
              <UiRadio
                checked={!selectedObjectValues?.active}
                value='include'
              />
            }
          />
          <UiFormControlLabel
            className='mr-0'
            label='انتخاب از بازه'
            control={
              <UiRadio checked={selectedObjectValues?.active} value='exclude' />
            }
          />
        </UiRadioGroup>
      )}
      <div className='flex center'>
        <UiIcon icon='ri-advertisement-line ml-12' />
        <div className='muted fs-12 w-20 text-center'>زیاد</div>
        <UiSlider
          disabled={
            hasActivateSwitch ? isDisabled : !selectedObjectValues?.active
          }
          isRtl={true}
          value={value}
          onChange={handleChangeing}
          onChangeCommitted={(event, newValue) =>
            handleChanged(newValue[0], newValue[1], true)
          }
          className='flex-1 ml-20 mr-10'
          size='small'
          min={0}
          max={1}
          disableSwap
          marks={marks}
          step={null}
          sx={{
            color: '#37AAAF',
          }}
        />
        <div className='muted fs-12 w-20 text-center'>کم</div>
      </div>
    </div>
  );
};

AdvertFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  className: PropTypes.string,
  parentPlatform: PropTypes.string,
};

/**
 * در این قسمت اسلاید از حالت استاندارد خود خارج شده استاندارد
 * یعنی کلا برای ارسال دیتا به بک‌اند از 4 عدد پیشفرض: 0 - 0.65 - 0.85 - 1 استفاده میکند
 * اما اسلایدر در حالت نمایش باید شامل 3 قسمت مساوی باشه
 * در نتیجه: اعداد موقع ذخیره شدن روی کانتکست باید تبدیل به 0.65 و 0.85 بشن
 * و وقتی هم که از کانتکست خوانده میشن باید مجدد به 0.33 و 0.66 تبدیل بشن.
 * مفهوم دیگر میزان تبلیغاتی بودن است
 * اگر تیک عدم نمایش تبلیغات زده شده بود، باید مقدار 0 و 0.15 به بک ارسال شده
 * اگر تیک برداشته شد، باید بازه اکتیو بشه و 0 و 1 انتخاب شده باشه
 */
